import type { FormxPhotoItem, IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxPhotosByProjectUseCase({ formxRepository }: Deps) {
  return async function listFormxPhotosByProject(projectId: string, limit?: number, offset?: number): Promise<FormxPhotoItem[]> {
    return formxRepository.listPhotosByProject(projectId, limit, offset);
  };
}
